module.exports = {
  contactCopy: [
    'Learn more about my passions and skillset and contact me via the channels below.'
  ],
  contactLinks: [
    {
      text: "Email Me",
      icon: "email",
      url: 'mailto:dsack7@gmail.com'
    },
    {
      text: "LinkedIn",
      icon: "LinkedIn",
      url: 'https://www.linkedin.com/in/daniel-sack/'
    },
    {
      text: "GitHub",
      icon: "GitHub",
      url: 'https://github.com/danpete'
    },
    {
      text: "View Resume",
      icon: "resume",
      url: '/dan_sack_resume.pdf'
    }
  ],
  unusedCopy: [
    'I\'m currently open to new opportunities and would love to hear from you!'
  ]
}